import { ApplyEwellUser, DEFAULT_APPLY_EWELL_USER } from "./../staff/index";

export interface BillingFile {
  id?: number;
  billing_id?: number;
  sort_no?: number;
  path: string;
  name: string;
  comment: string;
}

export const DEFAULT_BILLING_FILE = {
  id: 1,
  billing_id: 1,
  sort_no: undefined,
  path: "",
  name: "",
  comment: "",
};

export interface Billing {
  id: number;
  agreement_id: number;
  office_id: number;
  start_date: string;
  end_date: string;
  use_receipt_type: number;
  use_receipt_comment: string;
  account_notice_date: string;
  trial_start_date: string;
  trial_end_date: string;
  stop_date: string;
  stop_reason: number;
  stop_memo: string;
  pause_end: string;
  stop_date_pending: string;
  stop_reason_pending: number;
  stop_memo_pending: string;
  pause_end_pending: string;
  agreement_plan_type: number;
  agreement_plan_name: string;
  estimate_no: string;
  ewell_sales_staff_fullname: string;
  ewell_sales_staff_mail: string;
  customer_support_mail: string;
  first_login_id: string;
  first_login_password: string;
  group_office_code: string;
  /** 請求書紙出力対応フラグ 1:紙出力 */
  is_paper_invoice: number;
  post_code: string;
  pref: number;
  city: string;
  area: string;
  building: string;
  billing_name: string;
  billing_name_title_div: number;
  is_send_receipt_system: number;
  bank_selection: number;
  financial_code: string;
  branch_code: string;
  bank_name: string;
  bank_type: number;
  branch_name: string;
  branch_type: number;
  deposit_type: number;
  account_number: string;
  account_furigana: string;
  account_name: string;
  japan_post_bank_code: string;
  japan_post_bank_number: string;
  aplus_code: string;
  is_attendance_use: number;
  is_chiken_use: number;
  ibow_receipt_div: number;
  receipt_agreement_start_date: string;
  receipt_agreement_end_date: string;
  receipt_start_date: string;
  receipt_end_date: string;
  receipt_end_date_pending: string;
  receipt_is_send_receipt_system: number;
  receipt_notice_mailaddress: string;
  is_ocr_enabled: number;
  ocr_agreement_start_date: string;
  ocr_agreement_end_date: string;
  ocr_agreement_end_date_pending: string;
  ocr_start_date: string;
  ocr_end_date: string;
  ocr_end_date_pending: string;
  remarks: string;
  start_date_wareki: string;
  end_date_wareki: string;
  account_notice_date_wareki: string;
  trial_start_date_wareki: string;
  trial_end_date_wareki: string;
  stop_date_wareki: string;
  pause_end_wareki: string;
  updated_at: string;
  updated_at_wareki: string;
  billing_files: BillingFile[];
  confflag: number;
  billing_comments: BillingComment[];
  change_message: string;
  plan_storage: number;
  /** 計画書/報告書/利用者請求書/CSV出力設定（ソフィア用） */
  is_report_plan_receipt_csv_enabled: number;

  /** OJT研修機能 */
  use_ojt: number;
  /** OJT研修契約開始日 */
  ojt_agreement_start_date: string;
  /** OJT研修契約終了日 */
  ojt_agreement_end_date: string;
  /** OJT研修開始日 */
  ojt_start_date: string;
  /** OJT研修終了日 */
  ojt_end_date: string;
  /** OJT研修通知メール */
  ojt_notice_mailaddress: string;

  /** レセプト代行使用フラグ 0:未使用 1:使用 */
  receipt_agency_div: number;
  /** レセプト代行使用フラグ(未反映) 0:未使用 1:使用 */
  receipt_agency_div_pending: number;
  /** iBowレセプトボタン制御設定 0:OFF 1:ON */
  ibow_rec_btn_ctrl: number;
  /** iBowレセプトボタン制御設定(未反映) 0:OFF 1:ON */
  ibow_rec_btn_ctrl_pending: number;
  /** iBowレセプトボタン制御設定 開始日 */
  ibow_rec_btn_ctrl_start: string;
  /** iBowレセプトボタン制御設定 終了日 */
  ibow_rec_btn_ctrl_end: string;
  /** レセプト代行 ファイル登録通知先メールアドレス */
  billing_receipt_acting_mails: BillingReceiptActingMail[];

  /** レセプト事前チェック機能 0:未使用 1:使用 */
  use_receipt_pre_check: number;

  /** BI機能の有効/無効 0:無効 1:有効 */
  is_bi_enabled: number;
  /** iBowボード Pro 0:OFF 1:ON */
  is_biaggregate_enabled: number;
  /** BI 開始日 */
  bi_start_date: string;
  /** BI 終了日 */
  bi_end_date: string;
  /** BI 終了日(未反映) */
  bi_end_date_pending: string;
  /** BI 契約開始日 */
  bi_agreement_start_date: string;
  /** BI 契約終了日 */
  bi_agreement_end_date: string;
  /** BI 課金開始日 */
  bi_billing_start_date: string;
  /** BI 課金終了日 */
  bi_billing_end_date: string;
  /** BI バンドル適用開始日 */
  bi_bundle_start_date: string;
  /** BI バンドル適用終了日 */
  bi_bundle_end_date: string;
  /** BI 請求管理システム送信フラグ 0:送る 1:送らない */
  bi_is_send_receipt_system: number;
  /** BI 通知メールアドレス */
  bi_notice_mailaddress: string;
  /** BI 通知メール送信フラグ 0:未送信 1:送信済み */
  is_send_bi_notice_mail: number;

  /** iBowAI自動作成 看護計画書AI自動作成機能 0:OFF 1:ON */
  is_ai_enabled: number;
  /** iBowAI自動作成 月次報告書AI自動作成機能 0:OFF 1:ON */
  is_ai_month_report_enabled: number;
  /** iBowAI自動作成 月次報告書AI自動作成機能(別添) 0:OFF 1:ON */
  is_ai_month_report_betten_enabled: number;
  /** iBowAI自動作成 開始日 */
  ai_report_start_date: string;
  /** iBowAI自動作成 終了日 */
  ai_report_end_date: string;
  /** iBowAI自動作成 終了日(未反映) */
  ai_report_end_date_pending: string;
  /** iBowAI自動作成 契約開始日 */
  ai_report_agreement_start_date: string;
  /** iBowAI自動作成 契約終了日 */
  ai_report_agreement_end_date: string;
  /** iBowAI自動作成 課金開始日 */
  ai_report_billing_start_date: string;
  /** iBowAI自動作成 課金終了日 */
  ai_report_billing_end_date: string;
  /** iBowAI自動作成 請求管理システム送信フラグ 0:送る 1:送らない */
  ai_report_is_send_receipt_system: number;
  /** iBowAI自動作成 通知メールアドレス */
  ai_report_notice_mailaddress: string;
  /** 請求情報公開先iBowアカウント情報 */
  billing_ewell_users: BillingEwellUser[];
  /** けあログっと事業所ID */
  portal_office_id: number;
  /** AIRoute 0:OFF 1:ON */
  is_ai_route_enabled: number;
  /** AIRoute 開始日 */
  ai_route_start_date: string;
  /** AIRoute 終了日 */
  ai_route_end_date: string;
  /** AIRoute 終了日(未反映) */
  ai_route_end_date_pending: string;
  /** AIRoute 契約開始日 */
  ai_route_agreement_start_date: string;
  /** AIRoute 契約終了日 */
  ai_route_agreement_end_date: string;
  /** AIRoute 課金開始日 */
  ai_route_billing_start_date: string;
  /** AIRoute 課金終了日 */
  ai_route_billing_end_date: string;
  /** AIRoute 請求管理システム送信フラグ 0:送る 1:送らない */
  ai_route_is_send_receipt_system: number;
  /** AIRoute 通知メールアドレス */
  ai_route_notice_mailaddress: string;
  /** AIRoute 削除開始日 */
  ai_route_delete_start_date: string;
}

export const DEFAULT_BILLING: Billing = {
  id: 1,
  agreement_id: 1,
  office_id: 1,
  start_date: "",
  end_date: "",
  use_receipt_type: 1,
  use_receipt_comment: "",
  account_notice_date: "",
  trial_start_date: "",
  trial_end_date: "",
  stop_date: "",
  stop_reason: 1,
  stop_memo: "",
  pause_end: "",
  stop_date_pending: "",
  stop_reason_pending: 1,
  stop_memo_pending: "",
  pause_end_pending: "",
  agreement_plan_type: 1,
  agreement_plan_name: "",
  estimate_no: "",
  ewell_sales_staff_fullname: "",
  ewell_sales_staff_mail: "",
  customer_support_mail: "",
  first_login_id: "",
  first_login_password: "",
  group_office_code: "",
  is_paper_invoice: 0,
  post_code: "",
  pref: 1,
  city: "",
  area: "",
  building: "",
  billing_name: "",
  billing_name_title_div: 0,
  is_send_receipt_system: 1,
  bank_selection: 1,
  financial_code: "",
  branch_code: "",
  bank_name: "",
  bank_type: 1,
  branch_name: "",
  branch_type: 1,
  deposit_type: 1,
  account_number: "",
  account_furigana: "",
  account_name: "",
  japan_post_bank_code: "",
  japan_post_bank_number: "",
  aplus_code: "",
  is_attendance_use: 0,
  is_chiken_use: 0,
  ibow_receipt_div: 1,
  receipt_agreement_start_date: "",
  receipt_agreement_end_date: "",
  receipt_start_date: "",
  receipt_end_date: "",
  receipt_end_date_pending: "",
  receipt_is_send_receipt_system: 1,
  receipt_notice_mailaddress: "",
  is_ocr_enabled: 0,
  ocr_agreement_start_date: "",
  ocr_agreement_end_date: "",
  ocr_agreement_end_date_pending: "",
  ocr_start_date: "",
  ocr_end_date: "",
  ocr_end_date_pending: "",
  remarks: "",
  start_date_wareki: "",
  end_date_wareki: "",
  account_notice_date_wareki: "",
  trial_start_date_wareki: "",
  trial_end_date_wareki: "",
  stop_date_wareki: "",
  pause_end_wareki: "",
  updated_at: "",
  updated_at_wareki: "",
  billing_files: [] as BillingFile[],
  confflag: 1,
  billing_comments: [] as BillingComment[],
  change_message: "",
  plan_storage: 0,
  is_report_plan_receipt_csv_enabled: 0,
  use_ojt: 0,
  ojt_agreement_start_date: "",
  ojt_agreement_end_date: "",
  ojt_start_date: "",
  ojt_end_date: "",
  ojt_notice_mailaddress: "",
  receipt_agency_div: 0,
  receipt_agency_div_pending: 0,
  ibow_rec_btn_ctrl: 0,
  ibow_rec_btn_ctrl_pending: 0,
  ibow_rec_btn_ctrl_start: "",
  ibow_rec_btn_ctrl_end: "",
  billing_receipt_acting_mails: [],
  use_receipt_pre_check: 0,

  is_bi_enabled: 0,
  is_biaggregate_enabled: 0,
  bi_start_date: "",
  bi_end_date: "",
  bi_end_date_pending: "",
  bi_agreement_start_date: "",
  bi_agreement_end_date: "",
  bi_billing_start_date: "",
  bi_billing_end_date: "",
  bi_bundle_start_date: "",
  bi_bundle_end_date: "",
  bi_is_send_receipt_system: 0,
  bi_notice_mailaddress: "",
  is_send_bi_notice_mail: 0,

  is_ai_enabled: 0,
  is_ai_month_report_enabled: 0,
  is_ai_month_report_betten_enabled: 0,
  ai_report_start_date: "",
  ai_report_end_date: "",
  ai_report_end_date_pending: "",
  ai_report_agreement_start_date: "",
  ai_report_agreement_end_date: "",
  ai_report_billing_start_date: "",
  ai_report_billing_end_date: "",
  ai_report_is_send_receipt_system: 0,
  ai_report_notice_mailaddress: "",
  billing_ewell_users: [],
  portal_office_id: 0,
  is_ai_route_enabled: 0,
  ai_route_start_date: "",
  ai_route_end_date: "",
  ai_route_end_date_pending: "",
  ai_route_agreement_start_date: "",
  ai_route_agreement_end_date: "",
  ai_route_billing_start_date: "",
  ai_route_billing_end_date: "",
  ai_route_is_send_receipt_system: 0,
  ai_route_notice_mailaddress: "",
  ai_route_delete_start_date: "",
};

export interface BillingComment {
  id: number;
  billing_id: number;
  confflag: number;
  comment: string;
}

export const DEFAULT_BILLING_COMMENT: BillingComment = {
  id: 0,
  billing_id: 0,
  confflag: -2,
  comment: "",
};

/** 請求情報公開先iBowアカウント情報 */
export interface BillingEwellUser {
  /** ID */
  id: number;
  /** 請求ID */
  billing_id: number;
  /** iBowアカウントID */
  ewell_user_id: number;
  /** iBowアカウント情報 */
  ewell_user: ApplyEwellUser;
}

export const DEFAULT_BILLING_EWELL_USER: BillingEwellUser = {
  id: 0,
  billing_id: 0,
  ewell_user_id: 0,
  ewell_user: DEFAULT_APPLY_EWELL_USER,
};

/** レセプト代行 ファイル登録通知先メールアドレス */
export interface BillingReceiptActingMail {
  /** ID */
  id: number;
  /** 請求ID */
  billing_id: number;
  /** 並び順 */
  sort_no: number;
  /** 送付先メールアドレス */
  mail_address: string;
}

export const DEFAULT_BILLING_RECEIPT_ACTING_MAIL: BillingReceiptActingMail = {
  id: 0,
  billing_id: 0,
  sort_no: 0,
  mail_address: "",
};
